export default {"src":"/_next/static/media/neoverce-white.8abf78af.svg","height":81,"width":358,"blurWidth":0,"blurHeight":0};